module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [(!_vm.hasPosition) ? _c('div', {
    staticClass: "group support group--narrow db"
  }, [_c('h2', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("We are here to help you")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Are you in a position that is engaged or connected with the movement of the train or subject to Hours of Service laws and/or is subject to regulated drug testing by the Department of Transportation? "), _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.positions = !_vm.positions
      }
    }
  }, [_vm._v("View list of positions")])]), _vm._v(" "), (_vm.positions) ? _c('transition-expand-height', [_c('div', {
    staticClass: "grid grid--positions mt mb0"
  }, [_c('div', {
    staticClass: "grid__item grid__item--3"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("Locomotive Engineer")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("LEO and HEO (Class 4 Engineer)")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Stationary Engineer")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Conductor")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Assistant Conductor")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Flagman")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Train Dispatcher")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Load Dispatcher")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Power Director")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Block Operator")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--3"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("Leverman")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Train Director")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Signal Maintainer")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Cab Signal Electrician")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Machine Operator/EWE")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("M/W Repairmen")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Road Mechanic")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Watchmen")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Mechanical Repairmen")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Welders")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--3"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("Electricians (substation)")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Lineman")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Yardmaster")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Foremen")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Supervisors")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt0"
  }, [_c('module-button', {
    attrs: {
      "button": "primary",
      "label": "No"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextQuestion.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Yes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hasPosition = true
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasPosition) ? _c('div', {
    staticClass: "group group--narrow support db"
  }, [_c('h2', {
    staticClass: "h2 mt0"
  }, [_vm._v("Help is Available")]), _vm._v(" "), _c('p', {
    staticClass: "p mb0"
  }, [_vm._v("\n      You hold a safety-sensitive position, as defined by Amtrak policy. Please contact your EAP at " + _vm._s(_vm.org.safety_screen_phone) + ". Our care team has certified counselors available 24/7 that are ready to listen and direct you to the right help.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt0"
  }, [_c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Back to Homepage"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToHomepage.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d05c0886"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/questionnaire/SafetyScreen.vue
// module id = 462
// module chunks = 0